import HotelCardGalleryOverlay from './HotelCardGalleryOverlay';

export default HotelCardGalleryOverlay;
